/* eslint-disable jsx-a11y/no-noninteractive-element-interactions,no-unused-vars */
import React, { Component } from 'react';
import { selectAvatarPath } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import {
  initState,
  setFieldModelClass,
  setFieldModelId,
  setFieldContent,
  setFieldLike,
  sendForm
} from 'mt-react-common/modules/comments/reducers/form/actions';
import {
  selectFieldContent,
  selectFieldLike,
  selectResultObject
} from 'mt-react-common/modules/comments/reducers/form/selectors';
import {
  hasFieldError,
  selectFirstErrorByFiled
} from 'mt-react-common/common/reducers/_formErrors/reducer';
import { addItemToUp } from 'mt-react-common/common/reducers/_list/reducer';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectRequestStatusData } from 'mt-react-common/common/reducers/_requestStatus/reducer';
import { t } from 'utils/translates';

import CommentsStat from '../CommentStat/index';

class CommentForm extends Component {
  componentDidMount() {
    this.initState();
  }

  componentWillUpdate(nextProps) {
    if (
      nextProps.requestStatusData.codeResponse !==
        this.props.requestStatusData.codeResponse &&
      nextProps.requestStatusData.codeResponse === 201 &&
      this.props.selectResultObject
    ) {
      this.props.addItemToUp({
        itemId: nextProps.selectResultObject.id,
        item: nextProps.selectResultObject
      });
      this.initState();
    }
  }

  initState = () => {
    this.props.initState();
    this.props.setFieldModelClass(this.props.modelClass);
    this.props.setFieldModelId(this.props.modelId);
    this.props.setFieldLike(0);
    this.setState({ form: { like: 0 } });
  };

  handleChangeField = async event => {
    switch (event.target.name) {
      case 'content':
        this.props.setFieldContent(event.target.value);
        break;
      default:
        break;
    }
  };

  handleChangeLikeField = value => {
    if (value !== this.props.fieldLike.value) {
      this.props.setFieldLike(value);
    } else {
      this.props.setFieldLike(0);
    }
  };

  render() {
    const errorDesc = fieldName => {
      if (this.props.hasFieldError(fieldName)) {
        return (
          <small className="help-block">
            {this.props.selectFirstErrorByFiled(fieldName).message}
          </small>
        );
      }
      return null;
    };
    return (
      <div className="panel panel-default panel-heading_padding-large panel-body_bg-sub panel-footer_padding-large">
        <CommentsStat commentsStat={this.props.commentsInStat} />
        <div className="panel-body">
          <div className="media">
            <div className="media-left">
              <img
                alt=""
                className="media-object avatar avatar-sm"
                src={this.props.avatarPath}
              />
            </div>
            <div className="media-body full-width">
              <form>
                <div
                  className={`form-group ${
                    this.props.hasFieldError('content') ? 'has-error' : ''
                  }`}
                >
                  <textarea
                    onChange={this.handleChangeField}
                    value={this.props.fieldContent.value}
                    name="content"
                    className="form-control"
                    rows="3"
                    placeholder={t('Ваше слово')}
                  />
                  {errorDesc('content')}
                </div>
                <div className="btn-toolbar">
                  <button
                    type="button"
                    className="btn btn-primary pull-right"
                    onClick={() => this.props.sendForm()}
                  >
                    {t('Отправить')}
                  </button>
                  <div className="btn-group pull-right">
                    <label
                      onClick={() => this.handleChangeLikeField(1)}
                      htmlFor="option1"
                      className={`btn btn-default ${
                        this.props.fieldLike.value === 1 ? 'active' : ''
                      }`}
                    >
                      <i className="fa fa-thumbs-o-up" />
                    </label>
                    <label
                      onClick={() => this.handleChangeLikeField(-1)}
                      htmlFor="option2"
                      className={`btn btn-default ${
                        this.props.fieldLike.value === -1 ? 'active' : ''
                      }`}
                    >
                      <i className="fa fa-thumbs-o-down" />
                    </label>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CommentForm.propTypes = {
  modelClass: PropTypes.string.isRequired,
  modelId: PropTypes.number.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  commentsOwnerId: PropTypes.number.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  reducerName: PropTypes.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  listReducerName: PropTypes.string.isRequired,
  commentsInStat: PropTypes.shape({
    dislikes: PropTypes.number.isRequired,
    neutral: PropTypes.number.isRequired,
    likes: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
  }).isRequired,

  initState: PropTypes.func.isRequired,
  setFieldModelClass: PropTypes.func.isRequired,
  setFieldModelId: PropTypes.func.isRequired,
  setFieldContent: PropTypes.func.isRequired,
  setFieldLike: PropTypes.func.isRequired,
  sendForm: PropTypes.func.isRequired,
  addItemToUp: PropTypes.func.isRequired,

  avatarPath: PropTypes.string.isRequired,
  requestStatusData: PropTypes.shape({
    requestInProcess: PropTypes.bool,
    codeResponse: PropTypes.number
  }).isRequired,

  hasFieldError: PropTypes.func.isRequired,
  selectFirstErrorByFiled: PropTypes.func.isRequired,

  fieldContent: PropTypes.shape({
    value: PropTypes.any.isRequired
  }).isRequired,
  fieldLike: PropTypes.shape({
    value: PropTypes.any.isRequired
  }).isRequired,

  // eslint-disable-next-line react/require-default-props
  selectResultObject: PropTypes.shape({
    id: PropTypes.number
  })
};

const mapStateToProps = (state, props) => ({
  avatarPath: selectAvatarPath(state),
  requestStatusData: selectRequestStatusData(props.reducerName, state),
  hasFieldError: fieldName =>
    hasFieldError(state, props.reducerName, fieldName),
  selectFirstErrorByFiled: fieldName =>
    selectFirstErrorByFiled(state, props.reducerName, fieldName),
  selectResultObject: selectResultObject(state, props.reducerName),

  fieldContent: selectFieldContent(state, props.reducerName),
  fieldLike: selectFieldLike(state, props.reducerName)
});

const mapDispatchToProps = (dispatch, props) => ({
  initState: () => dispatch(initState(props.reducerName)),
  setFieldModelClass: value =>
    dispatch(setFieldModelClass(props.reducerName, value)),
  setFieldModelId: value => dispatch(setFieldModelId(props.reducerName, value)),
  setFieldContent: value => dispatch(setFieldContent(props.reducerName, value)),
  setFieldLike: value => dispatch(setFieldLike(props.reducerName, value)),
  sendForm: () => dispatch(sendForm(props.reducerName)),
  addItemToUp: payload => dispatch(addItemToUp(props.listReducerName, payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommentForm);



// WEBPACK FOOTER //
// ./src/components/Comment/CommentForm/CommentForm.js